import React, { useEffect, useState } from "react";
import { Package, Truck, Loader2, CheckCircle2 } from "lucide-react";
import { api, formatApiError } from "@/lib/wolfApi";
import { toast } from "sonner";

export const OrdersPanel = () => {
  const [orders, setOrders] = useState(null);
  const [shipping, setShipping] = useState(null);

  useEffect(() => {
    api.get("/merch/orders").then((r) => setOrders(r.data.orders)).catch(() => {});
  }, []);

  const markShipped = async (o) => {
    setShipping(o.session_id);
    try {
      const r = await api.post(`/merch/orders/${o.session_id}/ship`);
      setOrders((prev) => prev.map((x) => (x.session_id === o.session_id ? { ...x, shipped_at: r.data.shipped_at } : x)));
      toast.success("Marked as shipped — customer emailed 🐺");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setShipping(null);
    }
  };

  if (!orders) return null;

  return (
    <div className="mt-6 bg-[#111111] border border-[#D4AF37]/25 p-6" data-testid="orders-panel">
      <p className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]/90 mb-3">— Orders · Admin</p>
      {orders.length === 0 ? (
        <p className="text-sm text-white/45 flex items-center gap-2">
          <Package size={14} className="text-[#D4AF37]/60" /> No paid orders yet. They'll appear here the moment someone buys.
        </p>
      ) : (
        <ul className="space-y-4" data-testid="orders-list">
          {orders.slice(0, 8).map((o) => (
            <li key={o.session_id} className="border border-white/8 bg-[#0d0d0d] p-3" data-testid={`order-${o.session_id.slice(-8)}`}>
              <div className="flex items-center justify-between">
                <span className="font-display text-[#D4AF37]">${o.amount.toFixed(2)} AUD</span>
                <span className="text-[10px] text-white/40">{(o.updated_at || "").slice(0, 10)}</span>
              </div>
              <p className="text-xs text-white/70 mt-1.5">{(o.items_summary || []).join(" · ")}</p>
              {o.shipping && (
                <p className="text-[11px] text-white/45 mt-1.5">
                  {o.shipping.name} — {o.shipping.city}, {o.shipping.state} {o.shipping.postcode}
                </p>
              )}
              <div className="mt-2.5">
                {o.order_type === "dawg" ? (
                  <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] text-[#FF2B2B]/90">
                    💿 Digital — WOLF DAWG
                  </span>
                ) : o.shipped_at ? (
                  <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]/80" data-testid={`order-shipped-${o.session_id.slice(-8)}`}>
                    <CheckCircle2 size={12} /> Shipped {(o.shipped_at || "").slice(0, 10)}
                  </span>
                ) : (
                  <button
                    onClick={() => markShipped(o)}
                    disabled={shipping === o.session_id}
                    data-testid={`order-ship-btn-${o.session_id.slice(-8)}`}
                    className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-black bg-[#D4AF37] hover:bg-[#e6c457] disabled:opacity-60 px-3.5 py-2 font-bold transition-colors"
                  >
                    {shipping === o.session_id ? <Loader2 size={12} className="animate-spin" /> : <Truck size={12} />}
                    Mark as shipped
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
